import React, {Component} from 'react';
import $ from "jquery";
import BridalHairServices from './components/BridalHairServices';
import BridalMakeupServices from './components/BridalMakeupServices';
import HairServices from './components/HairServices';
import MakeupServices from './components/MakeupServices';
import HairServicesLearnMore from './components/HairServicesLearnMore';
import MakeupServicesLearnMore from './components/MakeupServicesLearnMore';
import BridalLearnMore from './components/BridalLearnMore';
import BridalMakeupLearnMore from './components/BridalMakeupLearnMore';
import PopupQtyMin from './components/PopupQtyMin';
import {browserHistory} from 'react-router'
import axios from 'axios';
import { BASE_URL } from './constants/api';

class ChooseServices extends Component {
    constructor(props) {
        super(props);
        this.handleStepChange = this.handleStepChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onBtnClickHandler = this.onBtnClickHandler.bind(this);
        this.handlePopupHair = this.handlePopupHair.bind(this);
        this.handlePopupMakeup = this.handlePopupMakeup.bind(this);
        this.handlePopupBridal = this.handlePopupBridal.bind(this);
        this.handlePopupBridalMakeup = this.handlePopupBridalMakeup.bind(this);
        this.activePopupQtyMin = this.activePopupQtyMin.bind(this);
        this.inactivePopupQtyMin = this.inactivePopupQtyMin.bind(this);


        this.state = {
            selectBookingFor: 'Personal',
            userData: {},
            sum: '0.00',
            num_qty: 0,
            popupHair: false,
            popupMakeup: false,
            popupBridal: false,
            popupBridalMakeup: false,
            popupQtyMin: false,
            services: [],
            servicesData: {},
            validField: ''
        }
    }

    componentWillMount() {
        let user = localStorage.getItem('user');
        if (!user) {
            browserHistory.push(`/StepOne`)
        } else {
            this.setState({userData: JSON.parse(localStorage.getItem('user'))});
            localStorage.removeItem("servicesData")
        }
    }

    componentDidMount() {
        let self = this;
        let config = {
            headers: {'access-token': this.state.userData['token']}
        };

        axios.get(`${BASE_URL}/api/v1/services?platform=web`, config)
            .then(function (response) {
                self.setState({services: response.data})
            }).catch(function (error) {
            if (error.response.data.type == "Unauthorized") {
                localStorage.removeItem("servicesData");
                localStorage.removeItem("appointment_details");
                localStorage.removeItem("appointment");
                localStorage.removeItem("services");
                localStorage.removeItem("user");
                alert(error.response.data.type);
                browserHistory.push(`/StepOne`)
            } else {
                alert(error.response.data.message);
            }
        });
    }

    activePopupQtyMin() {
        this.setState({popupQtyMin: true});
    }

    inactivePopupQtyMin(e) {
        this.setState({popupQtyMin: e});
    }

    handlePopupHair(e) {
        this.setState({popupHair: e});
    }

    handlePopupMakeup(e) {
        this.setState({popupMakeup: e});
    }

    handlePopupBridal(e) {
        this.setState({popupBridal: e});
    }

    handlePopupBridalMakeup(e) {
        this.setState({popupBridalMakeup: e});
    }

    onBtnClickHandler(e) {
        e.preventDefault();
        if (this.state.num_qty < 2) {
          this.activePopupQtyMin()
          return;
        }

        if (Object.keys(this.state.servicesData).length > 0) {
            localStorage.removeItem("servicesData");
            localStorage.setItem('servicesData', JSON.stringify(this.state.servicesData));
            localStorage.setItem('services', JSON.stringify(this.state.services));
            browserHistory.push(`/StepTwo`)
        } else {
            this.setState({validField: 'empty'})
        }
    }

    handleChange(event) {
        this.setState({selectBookingFor: event.target.value});
    }

    handleStepChange(serviceId, value) {
        let data = {};

        if (Object.keys(this.state.servicesData).length > 0 && serviceId in this.state.servicesData) {
            let copyServicesData = this.state.servicesData;
            if (value === 0) {
                delete copyServicesData[serviceId];
            } else {
                copyServicesData[serviceId] = value;
            }
            this.setState({userData: copyServicesData}, this.summation);

        } else {
            data[serviceId] = value;
            this.setState({servicesData: Object.assign({}, this.state.servicesData, data)}, this.summation);
        }
    }

    appendElement() {
        let data = this.state.servicesData;
        let productlineitems = [];

        for (let el in data) {
            let service = this.state.services.filter(function( obj ) {
                return obj.id == el;
            });
            productlineitems.push('<div class="pricerow"><div class="itemname">' + service[0].title + '</div><div class="itemprice">' + data[el] + ' x $' + service[0].price + '</div></div>')
        }

        $(".productpicked").empty();
        $(".productpicked").append(productlineitems);
        $(".productpicked").show();

    }

    summation() {
        let data = this.state.servicesData
        let result = 0.0

        for (var el in data) {
            let service = this.state.services.filter(function( obj ) {
                return obj.id == el;
            });
            result += (service[0].price * data[el])
        }
        const num_qty = Object.values(data).reduce((acc, value) => acc + value, 0);

        this.setState({sum: this.intToFloat(result, 2), num_qty: num_qty}, this.appendElement());
    }

    intToFloat(num, decPlaces) {
        return num.toFixed(decPlaces);
    }

    render() {
        let selectBookingFor = this.state.selectBookingFor;
        let popupHair = this.state.popupHair;
        let popupMakeup = this.state.popupMakeup;
        let popupBridal = this.state.popupBridal;
        let popupBridalMakeup = this.state.popupBridalMakeup;
        let popupQtyMin = this.state.popupQtyMin;


        return (
            <div>
                <div className="smart-wrap">
                    <div className="smart-forms smart-container wrap-2">
                        <div className="form-header header-lite">
                            <h4>Choose Your Services</h4>
                        </div>
                        <div className="form-body smart-steps steps-theme-primary">
                            <form id="smart-form">
                                <fieldset>
                                    <div className="frm-row">
                                        <div className="section colm colm12">
                                            <div className="spacer-b0">
                                                <div className="tagline">
                                                    <span>Booking For</span>
                                                </div>
                                            </div>
                                            <label className="field select">
                                                <select
                                                    id="bookingfor"
                                                    name="bookingfor"
                                                    value={this.state.selectBookingFor}
                                                    onChange={this.handleChange}
                                                >
                                                    <option className="smartfm-ctrl" value='Personal'
                                                            data-show-id="ctr_personal">Personal
                                                    </option>
                                                    <option className="smartfm-ctrl" value="Business"
                                                            data-show-id="ctr_personal">Business
                                                    </option>
                                                    <option className="smartfm-ctrl" value="Bridal"
                                                            data-show-id="ctr_bridal">
                                                        Bridal
                                                    </option>
                                                </select>
                                                <i className="arrow double"></i>
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        selectBookingFor === 'Personal' || selectBookingFor === 'Business' ?
                                            (
                                                <div id="ctr_personal" className="hiddenbox">
                                                    <HairServices
                                                        handleStepChange={this.handleStepChange}
                                                        handlePopupHair={this.handlePopupHair}
                                                        services={this.state.services}
                                                        validField={this.state.validField}
                                                    />
                                                    <MakeupServices
                                                        handleStepChange={this.handleStepChange}
                                                        handlePopupMakeup={this.handlePopupMakeup}
                                                        services={this.state.services}
                                                        validField={this.state.validField}
                                                    />
                                                </div>
                                            ) :
                                            (
                                                <div id="ctr_bridal" className="hiddenbox">
                                                    <BridalHairServices
                                                        handleStepChange={this.handleStepChange}
                                                        handlePopupBridal={this.handlePopupBridal}
                                                        services={this.state.services}
                                                        validField={this.state.validField}
                                                    />

                                                    <BridalMakeupServices
                                                        handleStepChange={this.handleStepChange}
                                                        handlePopupBridalMakeup={this.handlePopupBridalMakeup}
                                                        services={this.state.services}
                                                        validField={this.state.validField}
                                                    />
                                                </div>
                                            )
                                    }
                                    <div className="productpicked">
                                    </div>
                                    <div className="thetotals">
                                        <h1 className="page_totals">Subtotal $<span>{this.state.sum}</span></h1>
                                        <h4>(Taxes are calculated at checkout)</h4>
                                    </div>
                                    <div className="controls">
                                        <div className="sendit">
                                            <button
                                                type="submit"
                                                className="button btn-primary"
                                                onClick={this.onBtnClickHandler}
                                            > CONTINUE
                                            </button>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
                {
                    popupHair &&
                    <HairServicesLearnMore
                        handlePopupHair={this.handlePopupHair}
                    />
                }
                {
                    popupMakeup &&
                    <MakeupServicesLearnMore
                        handlePopupMakeup={this.handlePopupMakeup}
                    />
                }
                {
                    popupBridal &&
                    <BridalLearnMore
                        handlePopupBridal={this.handlePopupBridal}
                    />
                }
                {
                    popupBridalMakeup &&
                    <BridalMakeupLearnMore
                        handlePopupBridalMakeup={this.handlePopupBridalMakeup}
                    />
                }
                {
                    popupQtyMin &&
                    <PopupQtyMin
                        inactivePopupQtyMin={this.inactivePopupQtyMin}
                    />
                }
            </div>
        )
    }
}

export default ChooseServices;



/** WEBPACK FOOTER **
 ** ./src/ChooseServices.js
 **/